import { render } from "./PromReportsByPromView.vue?vue&type=template&id=235c80fd"
import script from "./PromReportsByPromView.vue?vue&type=script&lang=js"
export * from "./PromReportsByPromView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__